import React from 'react'
import DashboardSvg from 'images/modules/Manage/i-dashboard.svg?raw'

export { default as DashboardUrl } from 'images/modules/Manage/i-dashboard.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: DashboardSvg}} />
)
